import { BaseTheme as Theme } from '@blockanalitica/ui/package/types/src/theme/baseTheme';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function dropdownOption(theme: Theme): ComponentStyle {
  return {
    componentName: 'dropdownOption',
    baseStyle: {
      padding: `${theme.space['xs']} ${theme.space['2xs']}`,
      backgroundColor: 'rgba(108, 104, 255, 0.23)',
      cursor: 'pointer',
      borderBottom: `1px solid ${theme.colors.black23}`,
      fontSize: theme.sizes['-1'],

      ['&:hover']: {
        backgroundColor: theme.colors.link
      }
    }
  };
}
